/**
 * US-state "Do Not Sell or Share My Personal Information" opt-out control.
 *
 * layouts/partials/us-states-opt-out-flag.twig suppresses Google's own link, so this module
 * is the only entry point to the opt-out dialog.
 */

const LINK_SELECTOR = '[data-us-states-opt-out-link]';

/** @param {boolean} visible */
function setVisible(visible) {
    document.querySelectorAll(LINK_SELECTOR).forEach((el) => {
        el.hidden = !visible;
    });
}

/** @param {Object} api Google's googlefc.usstatesoptout namespace. */
function openDialog(api) {
    try {
        api.openConfirmationDialog((userOptedOut) => {
            if (userOptedOut === true) {
                setVisible(false);
            }
        });
    } catch {
        // Nothing was recorded, so the control stays for a retry.
    }
}

/** Runs when Google reports the initial US-state opt-out status. */
function onOptOutDataReady() {
    try {
        const api = window.googlefc && window.googlefc.usstatesoptout;
        const statuses = api && api.InitialUsStatesOptOutStatusEnum;
        if (!statuses || typeof api.getInitialUsStatesOptOutStatus !== 'function') {
            return;
        }
        if (api.getInitialUsStatesOptOutStatus() !== statuses.NOT_OPTED_OUT) {
            return;
        }
        document.querySelectorAll(LINK_SELECTOR).forEach((el) => {
            el.hidden = false;
            el.addEventListener('click', () => openDialog(api));
        });
    } catch {
        // Leave the control hidden.
    }
}

export function initUsStatesOptOut() {
    const queue = window.googlefc && window.googlefc.callbackQueue;
    if (!queue || typeof queue.push !== 'function') {
        return;
    }
    queue.push({ INITIAL_US_STATES_OPT_OUT_DATA_READY: onOptOutDataReady });
}
